module.exports = __webpack_public_path__ + "static/4-291cd4cbf53b4474f5399aab2831113d.jpg";